var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewAplIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "841.000000pt",
    height: "877.000000pt",
    viewBox: "0 0 841.000000 877.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,877.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2757 8759 c-75 -8 -112 -27 -129 -65 -26 -55 -5 -102 434 -993 115 -232 215 -448 223 -479 19 -73 19 -153 -1 -227 -8 -33 -101 -235 -206 -450 -264 -539 -390 -800 -1450 -3000 -512 -1062 -1083 -2246 -1269 -2632 -210 -434 -344 -722 -351 -755 -14 -66 0 -102 52 -132 34 -20 51 -21 592 -24 656 -3 777 3 863 44 117 54 141 90 329 479 93 193 291 600 439 905 148 305 527 1091 842 1745 648 1345 1032 2136 1044 2148 30 30 293 -506 2249 -4580 148 -309 286 -584 306 -611 19 -27 53 -61 75 -76 80 -56 81 -56 750 -56 548 0 629 2 734 19 64 10 119 20 121 22 2 2 -22 69 -54 150 -63 159 -114 265 -1610 3359 -1449 2996 -1722 3561 -2057 4260 -391 815 -382 797 -454 864 -103 96 -81 93 -794 93 -335 0 -641 -4 -678 -8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAplIconWhite);
export default __webpack_public_path__ + "static/media/new_apl_icon_white.9382c371.svg";
export { ForwardRef as ReactComponent };